import { ServiceBase } from "./ServiceBase";

export class EstoqueService extends ServiceBase {
    
    async postItem(url: string, body: any) {
        return this.post(url, body);
    }

    async putItem(url: string, body: any) {
        return this.put(url, body);
    }

    async getItems(url: string){
        return this.get(url);
    }

    async deleteItem(url: string) {
        return this.delete(url)
    }

    async getHistorico(url: string) {
        return this.get(url);
    }

}